import React from "react";
import {EntityHeader} from "../../../library/components/core";

export function CommunitySearchPage() {

    return <div>
        <EntityHeader title="Search" />
        Coming soon!
    </div>
}